var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobStatusUpdated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7167 7.94183L8.82508 13.8335L5.29175 10.3002L6.46675 9.12516L8.82508 11.4835L13.5417 6.76683L14.7167 7.94183ZM3.33341 10.0002C3.33341 8.0585 4.18341 6.31683 5.51675 5.10016L7.50008 7.0835V2.0835H2.50008L4.33341 3.91683C2.70008 5.4335 1.66675 7.59183 1.66675 10.0002C1.66675 14.3252 4.95841 17.8752 9.16675 18.2918V16.6085C5.88341 16.2002 3.33341 13.3918 3.33341 10.0002ZM18.3334 10.0002C18.3334 5.67516 15.0417 2.12516 10.8334 1.7085V3.39183C14.1167 3.80016 16.6667 6.6085 16.6667 10.0002C16.6667 11.9418 15.8167 13.6835 14.4834 14.9002L12.5001 12.9168V17.9168H17.5001L15.6667 16.0835C17.3001 14.5668 18.3334 12.4085 18.3334 10.0002Z",
    fill: "#248EB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobStatusUpdated);
export default __webpack_public_path__ + "static/media/job-status-updated.655d5220e2fe41da6f357e52e76e7142.svg";
export { ForwardRef as ReactComponent };